(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    subscribe(
      PUB_SUB_EVENTS.filestackFileChoiced,
      ({ data: { url } }) => {
        const form = document.querySelector('product-form form');
        const photo = form.querySelector('[name="properties[Photo]"]');
        if (photo) {
          photo.value = url;
        } else {
          const photo_input = document.createElement('input');
          photo_input.type = 'hidden';
          photo_input.value = url;
          photo_input.name = 'properties[Photo]';
          form.append(photo_input);
        }
      }
    )
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-additional"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    function renderAddonElement(button, index, method = 'add') {
      publish(PUB_SUB_EVENTS.productAdditional, {
        data: {
          target: button,
          index,
          method,
        },
      });
    }
    document.querySelectorAll('.additional-row button').forEach((button, index) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const form = document.querySelector('#' + button.getAttribute('form'))
        const addonInputs = form.querySelectorAll(`[data-addons-index="${index}"]`);
        if (addonInputs.length === 0) {
          button.textContent = button.dataset.textRemove;
          const inputProduct = document.createElement('input');
          const inputQuantity = document.createElement('input');
          inputProduct.setAttribute('type', 'hidden');
          inputProduct.setAttribute('name', `items[${index}][id]`);
          inputProduct.setAttribute('value', button.dataset.variantId);
          inputProduct.setAttribute('data-addons-index', index.toString());
          inputQuantity.setAttribute('type', 'hidden');
          inputQuantity.setAttribute('name', `items[${index}][quantity]`);
          inputQuantity.setAttribute('value', '1');
          inputQuantity.setAttribute('data-addons-index', index.toString());
          form.append(inputProduct, inputQuantity);
          renderAddonElement(button, index)
        } else {
          button.textContent = button.dataset.textAdd;
          renderAddonElement(button, index, 'remove');
          addonInputs.forEach((item) => {
            item.remove();
          })
        }
      })
    })
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-engrave-text"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".engrave-text").forEach((engraveText) => {
      const suggestions = engraveText.querySelector('[data-target="suggestions"]');
      const fontInput = engraveText.querySelector('.engrave-font-input');
      if (fontInput) {
        publish(PUB_SUB_EVENTS.engraveFontChanged, {
          data: {
            value: fontInput.value
          },
        });
      }
      engraveText.querySelectorAll(".type-text-input.engrave-text").forEach((input) => {
        const maxLength = parseInt(input.getAttribute("data-maxlength"), 10);
        const counter = input.parentElement.querySelector(".counter");

        if (!counter || isNaN(maxLength)) return;
        const limitMessage = counter.getAttribute('data-limit-message');

        counter.textContent = maxLength - input.value.length;

        let timeoutId;

        input.addEventListener("change", (event) => {
          clearTimeout(timeoutId);
          const form = document.querySelector('#' + event.target.getAttribute('form'))
          const oldInput = form.querySelector(`[name="${event.target.getAttribute('name')}"]`);
          if (oldInput) {
            oldInput.value = event.target.value;
          } else {
            const newInput = document.createElement('input');
            newInput.setAttribute('name', event.target.getAttribute('name'));
            newInput.setAttribute('type', 'hidden');
            newInput.value = event.target.value;
            form.append(newInput);
          }

          publish(PUB_SUB_EVENTS.engraveTextChanged, {
            data: {
              title: event.target.getAttribute('data-engrave-title'),
              value: event.target.value
            },
          });
        })

        input.addEventListener("blur", () => {
          clearTimeout(timeoutId);
          input.dispatchEvent(new Event('change', { bubbles: true }))
        });

        input.addEventListener("input", (event) => {
          const remaining = maxLength - input.value.length;
          if (limitMessage && remaining < 0) {
            counter.textContent = limitMessage.replace(':maxCharacters', Math.abs(remaining))
          } else {
            counter.textContent = remaining;
          }

          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            input.dispatchEvent(new Event('change', { bubbles: true }))
          }, 5000);
        });
        input.dispatchEvent(new Event('input', { bubbles: true }))
      });
      engraveText.querySelectorAll("[data-click='regenerate']").forEach((button) => {
        button.addEventListener('click', async (event) => {
          event.preventDefault();
          if (button.disabled) return;
          const locale = engraveText.dataset.aiLocale || document.documentElement.lang || 'en';
          const korean = /^ko(?:-|$)/i.test(locale);
          const status = engraveText.querySelector('[data-target="suggestion-status"]');
          const originalLabel = button.textContent;
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 20000);
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          button.textContent = korean ? '문구 만드는 중…' : 'Generating…';
          suggestions.replaceChildren();
          status.textContent = '';
          status.hidden = true;
          let generated = false;
          try {
            const response = await fetch('/apps/crystal-settings/api/v1/openai/responses', {
              method: 'POST',
              headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
              body: JSON.stringify({
                guidetext: engraveText.querySelector('[data-input="guidetext"]')?.value || '',
                occasion: engraveText.querySelector('[data-input="occasion"]')?.value || '',
                locale
              }),
              signal: controller.signal
            });
            if (!response.ok) throw new Error('Suggestions unavailable');
            const json = await response.json();
            if (!Array.isArray(json.suggestions) || json.suggestions.length !== 4 ||
                json.suggestions.some((idea) => typeof idea !== 'string' || !idea.trim() || idea.length > 40)) {
              throw new Error('Invalid suggestions');
            }
            json.suggestions.forEach((idea) => {
              const optionButton = document.createElement('button');
              optionButton.type = 'button';
              optionButton.classList.add('no-btn', 'text-item');
              optionButton.dataset.suggestion = idea;
              optionButton.textContent = idea;
              suggestions.append(optionButton);
              optionButton.addEventListener('click', (selectionEvent) => {
                selectionEvent.preventDefault();
                engraveText.querySelectorAll('.type-text-input.engrave-text').forEach((input) => {
                  input.value = idea;
                  input.dispatchEvent(new Event('change', { bubbles: true }));
                });
              });
            });
            status.textContent = typeof json.error === 'string' ? json.error : '';
            status.hidden = !status.textContent;
            generated = true;
          } catch (error) {
            status.textContent = korean
              ? '문구를 불러오지 못했어요. 다시 시도하거나 원하는 문구를 직접 입력해 주세요.'
              : 'Suggestions are unavailable right now. Please try again or enter your own text.';
            status.hidden = false;
          } finally {
            clearTimeout(timeout);
            button.disabled = false;
            button.removeAttribute('aria-busy');
            button.textContent = generated ? (button.dataset.adittionalText || originalLabel) : originalLabel;
          }
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form-total"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const freeLabel = document.querySelector('.product-form[data-free-label]')?.dataset.freeLabel || 'Free';
    const freePriceHtml = `<span class="price-item price-item--regular">${freeLabel}</span>`;
    subscribe(
      PUB_SUB_EVENTS.productFormUpdated,
      function () {
        document.querySelectorAll('.product-form ul').forEach((productForm) => {
          const totalPrice = productForm.querySelector('li.total .price .price-item--sale');
          const comparePrice = productForm.querySelector('li.total .price .price-item--regular');
          
          const total = Array.from(productForm.querySelectorAll('li [data-price]')).reduce((accumulator, currentValue) => accumulator + currentValue.dataset.price / 100, 0)
          const totalCompare = Array.from(productForm.querySelectorAll('li [data-compare-at-price]')).reduce((accumulator, currentValue) => accumulator + currentValue.dataset.compareAtPrice / 100, 0)
          const formatProductTotal = (value) => {
            const formattedValue = Math.round(value).toLocaleString(document.documentElement.lang || undefined);
            return productForm.dataset.moneyFormat.replace(/#(\.#+)?/, formattedValue);
          }
          const formattedTotal = formatProductTotal(total)
          totalPrice.innerText = formattedTotal
          comparePrice.innerText = formatProductTotal(totalCompare)
          document.querySelectorAll('.pdp-v2-mobile-purchase__price').forEach((mobilePrice) => {
            mobilePrice.innerText = formattedTotal
          })
          if (totalCompare > total) {
            comparePrice.removeAttribute('style');
          } else {
            comparePrice.style.display = 'none';
          }
        })
      }
    );
    const variationSelectedOptions = (selectedOptionValues) => {
      const options = [];
      selectedOptionValues.forEach((value) => {
        const element = document.createElement('li');
        const variation = document.querySelector(`variant-selects [data-option-value-id="${value}"]`);
        const group = variation.closest('.option-row');
        const title = group.querySelector('.row-heading .theme-title');
        const label = variation.closest('label');
        const price = label.querySelector('.price');
        const price_container = price.querySelector('.price__container');

        element.dataset.optionName = variation.getAttribute('name').trim();

        document.querySelectorAll(`.product-form ul li[data-option-name="${variation.getAttribute('name').trim()}"]`).forEach((el) => {
          el.remove();
        })

        const html = `<strong class="option-name">${title.innerText} ${price_container && price_container.dataset.salePercentage !== '0' ? `<span class="percent">${price_container.dataset.salePercentageMessage}</span>` : ''}</strong>
          <div class="price price--on-sale">
            ${price ? price.innerHTML : freePriceHtml}
          </div>
          <span class="option-descr">${variation.dataset.displayValue || variation.value}</span>`;

        element.innerHTML = html;
        options.push(element);
      })

      document.querySelectorAll(`.product-form ul`).forEach((item) => {
        options.reverse().forEach((option) => {
          item.prepend(option.cloneNode(true))
        })
      })

      publish(PUB_SUB_EVENTS.productFormUpdated, {
        data: {},
      });

      return options;
    }
    if (document.querySelector('variant-selects')) {
      variationSelectedOptions(document.querySelector('variant-selects').selectedOptionValues)
    }
    subscribe(
      PUB_SUB_EVENTS.optionValueSelectionChange,
      function ({ data: { event, target, selectedOptionValues } }) {
        variationSelectedOptions(selectedOptionValues)
      }
    );
    subscribe(
      PUB_SUB_EVENTS.engraveTextChanged,
      function ({data: { title, value } }) {
        const items = document.querySelectorAll(`.product-form ul li[data-engrave-message]`);
        const element = document.createElement('li');
        element.dataset.engraveMessage = "true";
        element.innerHTML = `<strong class="option-name">${title}</strong><div class="price price--on-sale">${freePriceHtml}</div><span class="option-descr">“${value}”</span>`;

        if (value.length > 0) {
          if (items.length) {
            items.forEach((item) => item.replaceWith(element.cloneNode(true)))
          } else {
            document.querySelectorAll(`.product-form ul`).forEach((item) => {
              item.insertBefore(element.cloneNode(true), item.lastElementChild);
            })
          }
        } else {
          items.forEach((item) => item.remove());
        }
      }
    );
    subscribe(
      PUB_SUB_EVENTS.productAdditional,
      function ({ data: { target, method } }) {
        const variantId = target.dataset.variantId;
        if (method === 'remove') {
          document.querySelectorAll(`.product-form ul li[data-variant-id="${variantId}"]`).forEach((item) => {
            item.remove();
          });
        } else {
          const productSalePrice = target.dataset.salePrice;
          const productPrice = target.dataset.productPrice;
          const productTitle = target.dataset.productTitle;
          const heading = target.dataset.heading;
          const parent = target.closest('li');
          const price = parent.querySelector('.form-wrap .price');
          const price_container = parent.querySelector('.form-wrap .price .price__container');

          const html = `<strong class="option-name">${heading} ${price_container && price_container.dataset.salePercentage !== '0' ? `<span class="percent">${price_container.dataset.salePercentageMessage}</span>` : ''}</strong>
          <div class="price price--on-sale">
            ${price ? price.innerHTML : freePriceHtml}
          </div>
            <span class="option-descr">${productTitle}</span>`;
          const element = document.createElement('li');
          element.dataset.variantId = variantId;
          element.innerHTML = html;
  
          document.querySelectorAll(`.product-form ul`).forEach((item) => {
            item.insertBefore(element.cloneNode(true), item.lastElementChild);
          })
        }

        publish(PUB_SUB_EVENTS.productFormUpdated, {
          data: {},
        });
      }
    );
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-special-instructions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.special-instructions textarea').forEach((textarea) => {
      textarea.addEventListener('input', (event) => {
        const form = document.querySelector('#' + event.target.getAttribute('form'));
        if (!form) return;
        const input = form.querySelector(`[name="${event.target.getAttribute('name')}"]`);
        if (input) {
          input.value = event.target.value;
        } else {
          const newInput = document.createElement('input');
          newInput.setAttribute('name', event.target.getAttribute('name'));
          newInput.setAttribute('type', 'hidden');
          newInput.value = event.target.value;
          form.append(newInput);
        }
      });
      textarea.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-upload-photo"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    window.CCMOpenProductPreview = window.CCMOpenProductPreview || (() => {
      const preview = document.querySelector('#pdp-korea-v2-live-preview');
      if (!preview) return;
      const photoTab = preview.querySelector('.tab-btn[data-tab-target="content-1"]');
      if (photoTab && !photoTab.classList.contains('active')) {
        photoTab.click();
      }
      preview.setAttribute('tabindex', '-1');
      preview.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
      preview.focus({ preventScroll: true });
    });

    document.querySelectorAll('.product-upload-photo').forEach((block) => {
      const chooseButton = block.querySelector(".theme-button-secondary");
      const dropArea = block.querySelector(".drop-area");
      const previewState = block.querySelector('[data-preview-state]');
      const previewImage = previewState?.querySelector('[data-preview-state-image]');
      const previewHeading = previewState?.querySelector('[data-preview-state-heading]');
      const previewBody = previewState?.querySelector('[data-preview-state-body]');
      const previewProgress = previewState?.querySelector('[data-preview-progress]');
      const previewAction = previewState?.querySelector('[data-preview-state-action]');
      let currentPreviewState = '';

      const displayImage = (url) => {
        const image = document.createElement('img');
        image.src = url;
        image.alt = block.dataset.uploadedAlt;
        dropArea.replaceChildren(image);
        chooseButton.textContent = block.dataset.changePhotoText;
      };

      const updatePreviewState = (detail) => {
        if (!previewState || detail.formId !== block.dataset.productFormId) return;
        const state = detail.state;
        const heading = previewState.dataset[`${state}Heading`];
        const body = previewState.dataset[`${state}Body`];
        if (!heading || !body) return;

        currentPreviewState = state;
        previewState.hidden = false;
        previewState.dataset.state = state;
        const isWorking = state === 'creating' || state === 'slow';
        previewHeading.textContent = isWorking && detail.stageLabel
          ? detail.stageLabel
          : heading;
        previewBody.textContent = body;
        if (previewProgress) {
          previewProgress.hidden = !['creating', 'slow'].includes(state);
          previewProgress.dataset.step = String(detail.stageIndex || 1);
        }

        const imageUrl = detail.thumbnailUrl || detail.imageUrl || dropArea.querySelector('img')?.src;
        if (detail.provider === 'v3' && imageUrl) {
          displayImage(imageUrl);
        }
        if (previewImage && imageUrl) {
          previewImage.src = imageUrl;
          previewImage.hidden = false;
        }

        if (previewAction) {
          if (state === 'ready') {
            previewAction.textContent = previewState.dataset.readyAction;
            previewAction.hidden = false;
          } else if (state === 'error') {
            previewAction.textContent = previewState.dataset.errorAction;
            previewAction.hidden = false;
          } else {
            previewAction.hidden = true;
          }
        }
      };

      document.addEventListener('ccm:preview-state', ({ detail }) => {
        updatePreviewState(detail);
      });

      previewAction?.addEventListener('click', () => {
        if (currentPreviewState === 'ready') {
          window.CCMOpenProductPreview();
        } else if (currentPreviewState === 'error') {
          chooseButton.click();
        }
      });

      subscribe(
        PUB_SUB_EVENTS.filestackFileChoiced,
        ({ data: { url }}) => {
          displayImage(url);
        },
      )
      // Native V3/accessory handlers own selection and signed cart binding.
    });
  });
  } catch(e) { console.error(e); }
})();

})();
